export enum Pages {
    Greeting,
    Approach,
    Core,
    Team,
    Last,
    Strategies,
    Technology
}